<template>
  <div>
    <Notification :notify="notify" />
      <div class="row">
        <div class="pl-3 col">
          <v-text-field
            v-model="Search"
            label="Search"
            required
            append-outer-icon="mdi-table-search"
            @click:append-outer="onSearch"
            v-on:keyup.enter="onSearch()"
          ></v-text-field>
        </div>
        <div class="col">
          <div class="float-right">
            
          </div>
        </div>
      </div>
    <div class="row">
      <div class="col">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr >
                <th class="text-left">ISBN</th>
                <th class="text-left">Title</th>
                <th class="text-left">No Of Copies</th>
                <th class="text-left">No Of Lending in PO</th>
                <!--<th class="text-left">Balance</th>-->
                <th style="width: 0px"></th>
              </tr>
            </thead>
            <tbody>
                <tr v-for="item in list" :key="item.id" v-bind:class="{danger:item.Balance < 0}">
                <td>{{ item.ISBN }}</td>
                <td>{{ item.Title }}</td>
                <td>{{ item.NoOfCopies }}</td>
                <td>{{ item.NoOfLending }}</td>
                <!--<td>{{ item.Balance }}</td>-->
                <td></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <Pagination :paging="paging" v-on:next="onNextPage" />
      </div>
    </div>
      <div class="row">
      <div class="col">
          <CancelPurchaseOrderLendingDetails> </CancelPurchaseOrderLendingDetails>
      </div>
    </div>
    
  </div> 
</template>
<script>
import * as api from "@/api";
import Notification from "@/components/Notification";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import Pagination from "@/components/Pagination";
import CancelPurchaseOrderLendingDetails from "@/components/PO-Cancellation/CancelPurchaseOrderLendingDetails";

export default {
  name: "CancelPurchaseOrderLending",
  components: {
    Notification,
    ConfirmationDialog,
    Pagination,
    CancelPurchaseOrderLendingDetails
  },
  props: {
    //organizationId: { type: Number, required: false}
  },
  watch: {},
  created() {
    this.getPublicationByPagin(this.$route.params.id);
  },
  methods: {
    onSearch() {
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getPublicationByPagin(this.$route.params.id);
    },
    onNextPage(page) {
      console.log("onNextPage " + page);
      this.paging.page = page;
      this.paging.keyword = this.Search;
      console.log(this.paging);

      this.getPublicationByPagin(this.$route.params.id);
    },
    getPurchaseOrder(id) {
      new Promise((resolve, reject) => {
        api
          .getByID("purchase-order", id)
          .then((response) => {
            resolve(response);
            console.log(response.data);
            this.item = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onSelect(obj) {
      console.log(obj);
      this.$emit("onSelect", obj);
    },
    getPublicationByPagin(id) {
      this.list = [];

      new Promise((resolve, reject) => {
        api
          .getByPagin("purchase-order/cancel/po-publication/lending/" + id + "/" + this.$route.params.organizationId, this.paging)
          .then((response) => {
            this.paging.count = response.data.count;
            this.list = response.data.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  data() {
    return {
      Search: "",
      item: {},
      list: [],
      details: [],
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      paging: { count: 10, page: 1, size: 10, keyword: "", isASC : false },
    };
  },
};
</script>
<style scoped>
  .danger{
     background-color:#FFCDD2;
    }
</style>


// WEBPACK FOOTER //
// src/components/PO-Cancellation/CancelPurchaseOrderLending.vue